(function () {
  const modal = document.querySelector('[data-request-quote-modal]');
  const trigger = document.querySelector('[data-request-quote-trigger]');

  if (!modal || !trigger) return;

  const frame = modal.querySelector('[data-request-quote-frame]');
  const closeButton = modal.querySelector('.request-quote-modal__close');
  const startSentinel = modal.querySelector('[data-request-quote-focus-start]');
  const endSentinel = modal.querySelector('[data-request-quote-focus-end]');
  let previouslyFocusedElement = null;
  let fallbackTimer = null;

  // The form URL is built server-side and the iframe loads eagerly, so it has
  // already started loading by the time this runs. Assigning src unconditionally
  // would reload the form on every product page view -- a wasted request on the
  // page this modal exists to speed up. Only reassign when enrichment actually
  // adds something, which is when the visitor arrived with campaign or click-ID
  // parameters we captured earlier in the session.
  if (window.EquippedMDLeadTracking) {
    const enrichedSrc = window.EquippedMDLeadTracking.enrichJotformUrl(frame.src);

    if (enrichedSrc !== frame.src) {
      frame.src = enrichedSrc;
    }
  }

  function markFrameLoaded() {
    window.clearTimeout(fallbackTimer);
    frame.removeAttribute('aria-hidden');
    frame.removeAttribute('tabindex');
    modal.classList.remove('is-delayed');
    modal.classList.add('is-loaded');
  }

  function showFallback() {
    if (!modal.classList.contains('is-loaded')) {
      modal.classList.add('is-delayed');
    }
  }

  function openModal() {
    if (modal.open) return;

    previouslyFocusedElement = document.activeElement;
    modal.hidden = false;
    modal.showModal();
    modal.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('request-quote-modal-open');
    document.body.classList.add('request-quote-modal-open');
    closeButton.focus();
  }

  function closeModal() {
    if (!modal.open) return;

    modal.close();
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('request-quote-modal-open');
    document.body.classList.remove('request-quote-modal-open');

    if (previouslyFocusedElement && previouslyFocusedElement.isConnected) {
      previouslyFocusedElement.focus();
    }
  }

  function trapFocus(event) {
    if (event.key !== 'Tab' || modal.hidden) return;

    const focusableElements = Array.from(
      modal.querySelectorAll('button:not([disabled]), iframe:not([tabindex="-1"]), a[href]')
    ).filter((element) => element.offsetParent !== null);

    if (!focusableElements.length) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  trigger.addEventListener('click', openModal);

  modal.addEventListener('click', function (event) {
    if (event.target === modal || event.target.closest('[data-request-quote-close]')) {
      closeModal();
    }
  });

  modal.addEventListener('cancel', function (event) {
    event.preventDefault();
    closeModal();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.open) {
      event.preventDefault();
      closeModal();
      return;
    }

    trapFocus(event);
  });

  frame.addEventListener('load', markFrameLoaded);
  startSentinel.addEventListener('focus', function () {
    if (modal.classList.contains('is-loaded')) {
      frame.focus();
    } else {
      closeButton.focus();
    }
  });
  endSentinel.addEventListener('focus', function () {
    closeButton.focus();
  });

  if (frame.dataset.loaded === 'true') {
    markFrameLoaded();
  } else {
    fallbackTimer = window.setTimeout(showFallback, 10000);
  }
})();
